import React from "react";
import Cart from "../components/Cart/Cart";

export default function CartPage() {
  return <Cart />;
}